import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "types/store";

import { Button } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import TestChatApp from "components/ChatApp/TestChatApp";
import TestChatAppReport from "components/ChatApp/TestChatAppReport";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import FlaskCircleIcon from "images/az_images/flask-circle.svg";

import * as viewReducer from "containers/View/reducer";
import * as chatAppReducer from "containers/ChatApp/reducer";

import styles from "./style.module.css";
import PlanetIcon from "images/az_images/ringed-planet-icon.svg";
import { Dialog, DialogContent } from "@/aible/Dialog/Dialog";

const TestChatAppReportView = () => {
  const dispatch = useDispatch();
  const isLoadingChatAnalytics = useSelector((state) => viewReducer.getIsLoadingChatAnalytics(state));
  const azTests = useSelector((state) => viewReducer.getChatApps(state, true, "AZ_TESTS"));
  const activeAzTests = useSelector((state) => chatAppReducer.getActiveAZTests(state));

  const [loading_state, updateLoadingState] = useState(0);
  const [showCreateModal, updateShowCreateModal] = useState(false);

  const shouldShowLoadingState = azTests?.length > 0 && isLoadingChatAnalytics;

  const mockLoading = (val) => {
    if (val < 5) {
      updateLoadingState(val);
      setTimeout(() => mockLoading(val + 1), 3000);
    }
  };

  useEffect(() => {
    mockLoading(0);
    dispatch(chatAppReducer.initAZTestReporting());
    return () => {
      // Deselect the modal when navigating away
      dispatch(viewReducer.updateSelectedAZTestModal(undefined));
    };
  }, []);

  if (shouldShowLoadingState) {
    return (
      <div className={styles.chatLoading}>
        <div className={styles.loadingHeader}>{"Loading A/Z Testing Reports..."}</div>
        <div>{"This will take longer for folders with a lot of projects."}</div>
        <div className={styles.loadingItem}>
          {loading_state === 0 ? (
            <LoadingIndicator style={{ margin: "0px", transform: "scale(0.5)" }} />
          ) : (
            <FontAwesomeIcon className={styles.loadIcon} icon={faCheckCircle} />
          )}
          <div className={styles.loadingText}>{"Evaluating all published Chat Apps"}</div>
        </div>
        <div className={styles.loadingItem}>
          {loading_state === 1 ? (
            <LoadingIndicator style={{ margin: "0px", transform: "scale(0.5)" }} />
          ) : loading_state < 1 ? (
            <div className={styles.loadIconCircle} />
          ) : (
            <FontAwesomeIcon className={styles.loadIcon} icon={faCheckCircle} />
          )}
          <div className={styles.loadingText}>{"Evaluating all chat activity"}</div>
        </div>
        <div className={styles.loadingItem}>
          {loading_state === 2 ? (
            <LoadingIndicator style={{ margin: "0px", transform: "scale(0.5)" }} />
          ) : loading_state < 2 ? (
            <div className={styles.loadIconCircle} />
          ) : (
            <FontAwesomeIcon className={styles.loadIcon} icon={faCheckCircle} />
          )}
          <div className={styles.loadingText}>{"Compiling chat feedback"}</div>
        </div>
        <div className={styles.loadingItem}>
          {loading_state >= 3 ? (
            <LoadingIndicator style={{ margin: "0px", transform: "scale(0.5)" }} />
          ) : loading_state < 3 ? (
            <div className={styles.loadIconCircle} />
          ) : (
            <FontAwesomeIcon className={styles.loadIcon} icon={faCheckCircle} />
          )}
          <div className={styles.loadingText}>{"Generating reports"}</div>
        </div>
      </div>
    );
  }

  const numActiveTests = activeAzTests?.length ?? 0;

  return (
    <div className={styles.testReportViewWrapper}>
      <TestChatApp showModal={showCreateModal} updateShowModal={(val) => updateShowCreateModal(val)} />
      <TestChatAppReportModal />
      <div className={styles.testReportViewHeader}>
        <div className={styles.testReportViewHeaderItem}>
          <div className={styles.testReportViewHeaderText}>
            {`${numActiveTests} Active Test${numActiveTests === 1 ? "" : "s"}`}
          </div>
        </div>
        <div className={styles.testReportViewHeaderItem}>
          <Button onClick={() => updateShowCreateModal(true)}>
            <img src={FlaskCircleIcon} className={styles.testReportButtonIcon} />
            {"Create New A/Z Test"}
          </Button>
        </div>
      </div>
      {!activeAzTests?.length && (
        <div
          style={{
            padding: "80px 20px 0",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <div style={{ marginBottom: "10px" }}>
            <img src={PlanetIcon} style={{ width: "24px", height: "24px" }} />
          </div>
          <div style={{ color: "#697586", marginBottom: "10px" }}>There are no active A/Z tests</div>
          <div>
            <Button onClick={() => updateShowCreateModal(true)}>Create New A/Z Test</Button>
          </div>
        </div>
      )}
      {activeAzTests.length > 0 && (
        <div className={styles.testReportViewBody}>
          {activeAzTests?.map((bp) => {
            return (
              <div
                key={bp?.id}
                className={styles.testReportViewBodyItem}
                onClick={() => {
                  dispatch(viewReducer.updateSelectedAZTestModal(bp?.id));
                }}
              >
                <TestChatAppReport id={bp?.id} />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const TestChatAppReportModal = () => {
  const dispatch = useDispatch();
  const id = useSelector((state) => viewReducer.getSelectedAZTestModal(state));
  const showModal = id !== undefined;

  const updateShowModal = (val) => {
    dispatch(viewReducer.updateSelectedAZTestModal(val ? val : undefined));
  };

  return (
    <Dialog
      open={showModal}
      onOpenChange={() => {
        updateShowModal(false);
      }}
    >
      <DialogContent size="xl">
        <div className={styles.testChatAppReportModalBody}>{showModal && <TestChatAppReport id={id} />}</div>
      </DialogContent>
    </Dialog>
  );
};

export default TestChatAppReportView;
